import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const IdentificationIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Identification</title>
    <path d="M28,4H9v13.1A8.44,8.44,0,0,0,4.72,19.4,8.59,8.59,0,0,0,9,33.79V38H9v6H40V16Zm0,5.75L34.25,16H28ZM10.83,32A6.59,6.59,0,0,1,6.14,20.82a6.43,6.43,0,0,1,4.57-1.89,6.62,6.62,0,0,1,6.61,6.57A6.45,6.45,0,0,1,10.86,32ZM11,34h-.12a6.08,6.08,0,0,0,.61,0C11.33,34,11.17,34,11,34ZM36,22V40H13V38h0V33.74a8,8,0,0,1-1.38.23,8.49,8.49,0,0,0,4.47-1.78l.71.7-.36.35,3.18,3.18,2.13-2.12-3.19-3.18-.35.35-.7-.7a8.38,8.38,0,0,0,1.81-5.27A8.57,8.57,0,0,0,13,17.25V8H24V20H36Z"/>
  </IconBase>
);
